import { useState } from 'react';
import { InputLabel } from '@/components/admin/input-label/InputLabel';
import { InputErrorWithCharacterCounter } from '@/components/admin/input-error-with-character-counter/InputErrorWithCharacterCounter';
import { TextAreaWithBulletBehavior } from '@/components/admin/textarea-with-bullets/TextAreaWithBulletBehavior';
import { COMMON_TEXT_ADMIN } from '@/const/admin/common';
import styles from './TitleDescriptionCardsSection.module.scss';

interface CardDescriptionFieldProps {
    label: string;
    id: string;
    name: string;
    value: string;
    isRequired?: boolean;
    onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
    onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
    onFocus?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
    maxLength: number;
    disabled?: boolean;
    placeholder?: string;
    rows?: number;
    autoGrow?: boolean;
    maxRows?: number;
    error?: string | undefined;
    currentLength?: number;
}

export const CardDescriptionField = ({
    label,
    id,
    name,
    value,
    isRequired,
    onChange,
    onBlur,
    onFocus,
    maxLength,
    disabled,
    placeholder,
    rows = 6,
    autoGrow = true,
    maxRows = 10,
    error,
}: CardDescriptionFieldProps) => {
    const counterId = `${id}-character-count`;
    const [localWarning, setLocalWarning] = useState<string | null>(null);

    return (
        <div className={styles['input-group']}>
            <InputLabel htmlFor={id} text={label} isRequired={isRequired} />

            <TextAreaWithBulletBehavior
                id={id}
                name={name}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                onFocus={onFocus}
                maxLength={maxLength}
                disabled={disabled}
                placeholder={placeholder}
                rows={rows}
                autoGrow={autoGrow}
                maxRows={maxRows}
                hasError={!!error || !!localWarning}
                maxLimitWarning={COMMON_TEXT_ADMIN.VALIDATION_MESSAGE.getMaxError(maxLength)}
                onWarningChange={setLocalWarning}
            />

            <InputErrorWithCharacterCounter
                error={localWarning || error}
                maxLength={maxLength}
                counterId={counterId}
                htmlFor={id}
                value={value}
            />
        </div>
    );
};

export default CardDescriptionField;
